import React, { useState } from 'react';
import { Modal, notification, Space, Spin, Upload } from 'antd';
import { InboxOutlined, LoadingOutlined } from '@ant-design/icons';
import { getStorageService } from '../storage/storage';
import { useTranslation } from 'react-i18next';

const { Dragger } = Upload;

const DocumentUploader = ({ disabledAdd, maxImageSize, storageFolder, fileList, setFileList, multiple }) => {
  const { t } = useTranslation();
  const [uploadInProgress, setUploadInProgress] = useState(false);

  // Initialize storage service
  const storageService = getStorageService(storageFolder);

  const onChange = (e) => {
    // 
  };

  const customUploadRequest = async (e) => {
    if (e.file) {
      setUploadInProgress(true);
      try {
        const { originalUrl } = await storageService.uploadDocument(e.file);
        setFileList(prev => [...prev, {
          uid: e.file.uid,
          name: e.file.name,
          url: originalUrl,
        }]);
      } catch (error) {
        console.log('Upload error:', error);
        notification['error']({
          message: t('documentUploader.uploadFailed'),
          description: t('documentUploader.uploadFailed'),
        });
      } finally {
        setUploadInProgress(false);
      }
    }
  };

  const onRemove = async (file) => {
    try {
      await storageService.deleteFiles(file.name);
      notification['info']({
        message: t('documentUploader.removed'),
        description: t('documentUploader.removed'),
      });
      const tempFileList = fileList.filter(f => !(f.uid === file.uid && f.name === file.name));
      setFileList(tempFileList);
    } catch (error) {
      console.error("File couldn't be deleted:", error);
      notification['error']({
        message: t('documentUploader.removeFailed'),
        description: t('documentUploader.removeFailed'),
      });
    }
  };

  const onDownload = (e) => {
    // 
  };

  const onDrop = (e) => {
    // 
  };

  return (
    <div>
      <Dragger
        fileList={fileList}
        onChange={onChange}
        customRequest={customUploadRequest}
        onRemove={onRemove}
        onDownload={onDownload}
        multiple={multiple}
        disabled={disabledAdd || fileList.length >= maxImageSize}
        onDrop={onDrop}
        showUploadList={{
          showRemoveIcon: !disabledAdd,
        }}
        maxCount={maxImageSize}
      >
        <p className="ant-upload-drag-icon">
          {uploadInProgress ?
            (<Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />)
            : (<InboxOutlined />)}
        </p>
        <p className="ant-upload-text">{t('documentUploader.selectDocument')}</p>
        <p className="ant-upload-hint">
          {t('documentUploader.maxFileSize', { size: maxImageSize })}
        </p>
      </Dragger>
    </div>
  );
};

export default DocumentUploader;